import firebase from 'firebase';
import {database} from '../app-database';
import { servicios } from './../properties';

const urlBASE = servicios.directorio.endPoint;
const urlBASEPlanNP = servicios.directorio.endPointPlanNP;

export const apiKeyMaps = servicios.directorio.apikeyMaps;


export const urlDirectorioBase = urlBASE;

export const medicosCarga = (_idMunicipio, _idEstado, _idEspecialidad, _idCirculo, nombre, apaterno, amaterno) => {
    return dispatch => {
        let queryString = {};
        if(nombre.length > 0){
            queryString.nombre = nombre;
        } 

        if(apaterno.length > 0){
            queryString.apaterno = apaterno;
        }

        if(amaterno.length > 0){
            queryString.amaterno = amaterno;
        }

        let url = "";
        if(_idMunicipio == 0 && _idEstado == 0 && _idEspecialidad == 0 && _idCirculo == 0){
            url = urlBASE+"/directorios/medicos";
        }

        if(_idMunicipio == 0 && _idEstado > 0 && _idEspecialidad == 0 && _idCirculo == 0){
            url = urlBASE+"/directorios/estados/"+_idEstado+"/medicos";
        }

        if(_idMunicipio > 0 && _idEstado > 0 && _idEspecialidad == 0 && _idCirculo == 0){
            url = urlBASE+"/directorios/municipios/"+_idMunicipio+"/medicos";
        }

        if(_idMunicipio == 0 && _idEstado == 0 && _idEspecialidad > 0 && _idCirculo == 0){
            url = urlBASE+"/directorios/especialidades/"+_idEspecialidad+"/medicos";
        }

        if(_idMunicipio == 0 && _idEstado == 0 && _idEspecialidad == 0 && _idCirculo > 0){
            url = urlBASE+"/directorios/circulos/"+_idCirculo+"/medicos";
        }

        if(_idMunicipio == 0 && _idEstado > 0 && _idEspecialidad == 0 && _idCirculo > 0){
            url = urlBASE+"/directorios/estados/"+_idEstado+"/circulos/"+_idCirculo+"/medicos";
        }

        if(_idMunicipio == 0 && _idEstado > 0 && _idEspecialidad > 0 && _idCirculo == 0){
            url = urlBASE+"/directorios/estados/"+_idEstado+"/especialidades/"+_idEspecialidad+"/medicos";
        }

        if(_idMunicipio == 0 && _idEstado > 0 && _idEspecialidad > 0 && _idCirculo > 0){
            url = urlBASE+"/directorios/estados/"+_idEstado+"/especialidades/"+_idEspecialidad+"/circulos/"+_idCirculo+"/medicos";
        }

        if(_idMunicipio > 0 && _idEstado > 0 && _idEspecialidad > 0 && _idCirculo == 0){
            url = urlBASE+"/directorios/municipios/"+_idMunicipio+"/especialidades/"+_idEspecialidad+"/medicos";
        }

        if(_idMunicipio > 0 && _idEstado > 0 && _idEspecialidad == 0 && _idCirculo > 0){
            url = urlBASE+"/directorios/municipios/"+_idMunicipio+"/circulos/"+_idCirculo+"/medicos";
        }

        if(_idMunicipio > 0 && _idEstado > 0 && _idEspecialidad > 0 && _idCirculo > 0){
            url = urlBASE+"/directorios/municipios/"+_idMunicipio+"/especialidades/"+_idEspecialidad+"/circulos/"+_idCirculo+"/medicos";
        }
        
        dispatch({ "type": "LOADER_SHOW" });
        $.ajax({
            method: "GET",
            data: queryString,
            url: url,
            dataType: "json",
            success: (data) => {
                //console.log(data);
                dispatch({ "type": "LOADER_HIDE" });
                dispatch({ "type": "DIRECTORIO_LLENAR_MEDICOS", "listaMedicos": data });
                dispatch({ "type": "DIRECTORIO_FINALIZO", "finalizo": true });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": false });
            },
            error: (error) => {
                dispatch({ "type": "LOADER_HIDE" });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": true });
                console.log(error);
            }
        });
    }
}

export const hospitalesCarga = (_idEstado, _idMunicipio, _idPlan) => {
    return dispatch => {
        let url = "";

        if(_idPlan === "PlanNacional" ||_idPlan === "PlanNacionalPlus"  ){
          
            dispatch({ "type": "LOADER_SHOW" });
            $.ajax({
                method: "POST",
                data:{
                    "municipio":_idMunicipio,
                    "estado":_idEstado,
                    "plan":_idPlan
                },
                url: urlBASEPlanNP,
                dataType: "json",
                success: (data) => {
                    dispatch({ "type": "LOADER_HIDE" });
                    dispatch({ "type": "DIRECTORIO_LLENAR_HOSPITALES", "listaHospitales": data });
                    dispatch({ "type": "DIRECTORIO_FINALIZO", "finalizo": true });
                    dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": false });
                },
                error: (error) => {
                    dispatch({ "type": "LOADER_HIDE" });
                    dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": true });
                }
            });
        }else{
            if(_idMunicipio == 0 && _idEstado == 0 && _idPlan == 0){
                url = urlBASE+"/directorios/hospitalesplanes";
            }

            if(_idMunicipio == 0 && _idEstado > 0 && _idPlan == 0){
                url = urlBASE+"/directorios/estados/"+_idEstado+"/hospitales";
            }

            if(_idMunicipio > 0 && _idEstado > 0 && _idPlan == 0){
                url = urlBASE+"/directorios/municipios/"+_idMunicipio+"/hospitales";
            }

            if(_idMunicipio == 0 && _idEstado == 0 && _idPlan > 0){
                url = urlBASE+"/directorios/planes/"+_idPlan+"/hospitales";
            }

            if(_idMunicipio == 0 && _idEstado > 0 && _idPlan > 0){
                url = urlBASE+"/directorios/estados/"+_idEstado+"/planes/"+_idPlan+"/hospitales";
            }

            if(_idMunicipio > 0 && _idEstado > 0 && _idPlan > 0){
                url = urlBASE+"/directorios/municipios/"+_idMunicipio+"/planes/"+_idPlan+"/hospitales";
            }

            dispatch({ "type": "LOADER_SHOW" });
            $.ajax({
                method: "GET",
                url: url,
                dataType: "json",
                success: (data) => {
                    dispatch({ "type": "LOADER_HIDE" });
                    dispatch({ "type": "DIRECTORIO_LLENAR_HOSPITALES", "listaHospitales": data });
                    dispatch({ "type": "DIRECTORIO_FINALIZO", "finalizo": true });
                    dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": false });
                },
                error: (error) => {
                    dispatch({ "type": "LOADER_HIDE" });
                    dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": true });
                }
            });
           
        }
    }
}

export const estadosCarga = () => {
    return dispatch => {
        console.log("@@@@@@@@@@@@@@@@@@@@@ estadosCarga @@@@@@@@@@@@@@@@@@@@");
        console.log(urlBASE + "/directorios/estados");
        $.ajax({
            method: "GET",
            url: urlBASE+"/directorios/estados",
            dataType: "json",
            success: (data) => {
                dispatch({ "type": "DIRECTORIO_LLENAR_ESTADOS", "estados": data });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": false });
            },
            error: (error) => {
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": true });
            }
        });
    }
}

export const municipiosCarga = (_idEstado) => {
    return dispatch => {
        console.log("@@@@@@@@@@@@@@@@@@@@@ municipiosCarga @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
        console.log(urlBASE + "/directorios/estados/" + _idEstado + "/municipios");
        $.ajax({
            method: "GET",
            url: urlBASE+"/directorios/estados/"+_idEstado+"/municipios",
            dataType: "json",
            success: (data) => {
                dispatch({ "type": "DIRECTORIO_LLENAR_MUNICIPIOS", "municipios": data });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": false });
            },
            error: (error) => {
                dispatch({ "type": "LOADER_HIDE" });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": true });
            }
        });
    }
}

export const especialidadesCarga = () => {
    return dispatch => {
        $.ajax({
            method: "GET",
            url: urlBASE+"/directorios/especialidades?x=c",
            dataType: "json",
            success: (data) => {
                dispatch({ "type": "DIRECTORIO_LLENAR_ESPECIALIDADES", "especialidades": data });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": false });
            },
            error: (error) => {
                dispatch({ "type": "LOADER_HIDE" });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": true });
            }
        });
    }
}

export const circulosCarga = (contrato) => {
    return dispatch => {
        $.ajax({
            method: "GET",
            url: urlBASE+"/directorios/circulos/"+contrato,
            dataType: "json",
            success: (data) => {
                dispatch({ "type": "DIRECTORIO_LLENAR_CIRCULOS", "circulos": data });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": false });
            },
            error: (error) => {
                dispatch({ "type": "LOADER_HIDE" });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": true });
            }
        });
    }
}

export const planesCarga = () => {
    return dispatch => {
        $.ajax({
            method: "GET",
            url: urlBASE+"/directorios/planes?x=e",
            dataType: "json",
            success: (data) => {
                dispatch({ "type": "DIRECTORIO_LLENAR_PLANES", "planes": data });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": false });
                localStorage.setItem("planesGNP", JSON.stringify(data));
            },
            error: (error) => {
                dispatch({ "type": "LOADER_HIDE" });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": true });
            }
        })
    }
}

export const planesSubplanCarga = () => {
    return dispatch => {
        $.ajax({
            method: "GET",
            url: urlBASE+"/directorios/planes-subplanes",
            dataType: "json",
            success: (data) => {
                dispatch({ "type": "DIRECTORIO_LLENAR_PLANES_SUBPLANES", "planesSubplanes": data });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": false });
            },
            error: (error) => {
                dispatch({ "type": "LOADER_HIDE" });
                dispatch({ "type": "ERROR_SERVIDOR", "errorServidor": true });
            }
        });
    }
}

export const actualizaFlagMarcadores = (_paso) => {
    return dispatch => {
        if(_paso == 2){
            dispatch({ "type": "DIRECTORIO_MARCADORES_FLAG", "marcadoresFlag": true});
        }

        if(_paso == 1){
            dispatch({ "type": "DIRECTORIO_MARCADORES_FLAG", "marcadoresFlag": false});
        }
    }
}

export const marcadoresCarga = (_markers) => {
    return dispatch => {
        dispatch({ "type": "DIRECTORIO_LLENAR_MARCADORES", "listaMarcadores": _markers });
    }
}

export const municipiosPromise = () => {
    return firebase.database().ref("catalogos/municipios").once("value");
}



// WEBPACK FOOTER //
// ./src/directorio/directorio.act.js